// src/useIdleLogout.js
import { useEffect, useRef } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';

/**
 * Desloga o usuário automaticamente após `timeoutMs` milissegundos de inatividade.
 * A contagem é reiniciada a cada interação (mouse, teclado, toque, scroll).
 *
 * @param {number} timeoutMs - Tempo de inatividade em ms. Padrão: 3.600.000 (1 hora).
 */
export function useIdleLogout(timeoutMs = 60 * 60 * 1000) {
    const timerRef = useRef(null);

    useEffect(() => {
        const resetTimer = () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                signOut(auth);
            }, timeoutMs);
        };

        const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];
        EVENTS.forEach(ev => window.addEventListener(ev, resetTimer, { passive: true }));

        resetTimer(); // inicia contagem ao montar

        return () => {
            EVENTS.forEach(ev => window.removeEventListener(ev, resetTimer));
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [timeoutMs]);
}
